"use client";

import dynamic from "next/dynamic";
import { useState } from "react";
import { Plus, Wallet } from "lucide-react";

import { formatDecimalString } from "@/lib/token-amount";
import "./topup.css";

const DepositDialog = dynamic(() => import("./dialogs/DepositDialog"), { ssr: false });

/**
 * NOT ENOUGH TO DO THIS — said where the action is, with the way to fix it beside it: how much it needs, how much can
 * be spent now (the locked part is not), and «افزایش موجودی», which opens the deposit right here on the same network.
 * The action's own button is off meanwhile (the caller's). One notice for every spend: an offer, a bid, a mint.
 */
export default function TopUpNotice({ lang, need, have, symbol, walletId }: {
  lang: "fa" | "en"; need: string | number; have: number; symbol: string; walletId?: number;
}) {
  const isFa = lang === "fa";
  const t = (fa: string, en: string) => (isFa ? fa : en);
  const [open, setOpen] = useState(false);
  const fmt = (v: string | number) => formatDecimalString(String(v), { locale: lang, maxFractionDigits: 6 }, "0");
  const sym = symbol.toUpperCase();
  return (
    <>
      <div className="tu-note" role="status">
        <span className="tu-mark" aria-hidden><Wallet /></span>
        <p>
          <b>{t("موجودی کیف پول کافی نیست", "Not enough in your wallet")}</b>
          <span>
            {t("لازم:", "Needed:")} <bdi dir="ltr">{fmt(need)} {sym}</bdi>
            <span className="tu-sep" aria-hidden>·</span>
            {t("قابل استفاده:", "Spendable:")} <bdi dir="ltr">{fmt(have)} {sym}</bdi>
          </span>
        </p>
        <button type="button" className="v2-btn v2-btn--sm tu-go v2-focus" onClick={() => setOpen(true)}>
          <Plus aria-hidden />{t("افزایش موجودی", "Top up")}
        </button>
      </div>
      {open ? <DepositDialog open onOpenChange={(o) => { if (!o) setOpen(false); }} lang={lang} initialWalletId={walletId} /> : null}
    </>
  );
}
